import React, { Fragment, useState } from "react"
import PropTypes from "prop-types"
import {
  useTable,
  useGlobalFilter,
  useAsyncDebounce,
  useSortBy,
  useExpanded,
  usePagination,
} from "react-table"
import { Table, Row, Col, Button, Label } from "reactstrap"
// import JobListGlobalFilter from "./GlobalSearchFilter"
import { Link } from "react-router-dom"
import Select from "react-select"

// Define a default UI for filtering
function GlobalFilter({
  preGlobalFilteredRows,
  globalFilter,
  setGlobalFilter,
  isJobListGlobalFilter,
}) {
  const count = preGlobalFilteredRows.length
  const [value, setValue] = React.useState(globalFilter)
  const onChange = useAsyncDebounce(value => {
    setGlobalFilter(value || undefined)
  }, 200)

  return (
    <React.Fragment>
      <Col xxl={2} lg={2}>
        <input
          type="search"
          className="form-control mb-3"
          id="search-bar-0"
          value={value || ""}
          placeholder={`${count} records...`}
          onChange={e => {
            setValue(e.target.value)
            onChange(e.target.value)
          }}
        />
      </Col>
      {/* <JobListGlobalFilter setGlobalFilter={setGlobalFilter} /> */}
    </React.Fragment>
  )
}

const TableContainer = ({
  initialPageIndex = 0,
  onPageChange,
  columns,
  data,
  isGlobalFilter,
  isJobListGlobalFilter,
  isAddOptions,
  isAddUserList,
  handleOrderClicks,
  handleCustomerClick,
  isAddCustList,
  customPageSize,
  customPageSizeOptions,
  iscustomPageSizeOptions,
  isPagination,
  isShowingPageLength,
  paginationDiv,
  pagination,
  tableClass,
  theadClass,
}) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      // defaultColumn: { Filter: DefaultColumnFilter },
      initialState: {
        pageIndex: initialPageIndex, // Use passed initial page
        pageSize: customPageSize,
        sortBy: [
          {
            id: "srNo",
            desc: false,
          },
        ],
      },
    },
    useGlobalFilter,
    // useFilters,
    useSortBy,
    useExpanded,
    usePagination
  )
  React.useEffect(() => {
    if (onPageChange) {
      onPageChange(pageIndex);
    }
  }, [pageIndex, onPageChange]);

  const generateSortingIndicator = column => {
    return column.isSorted ? (column.isSortedDesc ? " 🔽" : " 🔼") : ""
  }

  const onChangeInSelect = event => {
    setPageSize(Number(event.target.value))
  }

  //
  const [selectedStatus, setselectedStatus] = useState(null)
  function handleSelectGroup(selectedStatus) {
    setselectedStatus(selectedStatus)
  }
  return (
    <Fragment>
      <Row className="mb-2">
        {iscustomPageSizeOptions && (
          <Col md={customPageSizeOptions ? 2 : 1}>
            <select
              className="form-select"
              value={pageSize}
              onChange={onChangeInSelect}
            >
              {[10, 20, 30, 40, 50].map(pageSize => (
                <option key={pageSize} value={pageSize}>
                  Show {pageSize}
                </option>
              ))}
            </select>
          </Col>
        )}
        
      </Row>
      <Row>
        {isGlobalFilter && (
          <GlobalFilter
            preGlobalFilteredRows={preGlobalFilteredRows}
            globalFilter={state.globalFilter}
            setGlobalFilter={setGlobalFilter}
            isJobListGlobalFilter={isJobListGlobalFilter}
          />
        )}
      </Row>

      <div className="table-responsive" style={{ overflowY: "auto", maxHeight: "500px",  }}>
      {/* <div className="table-responsive" style={{ overflowY: "auto", maxHeight: "500px" }}> */}
        <Table {...getTableProps()} className={`${tableClass}`} >
          <thead className={theadClass} >
            {headerGroups.map(headerGroup => (
              <tr key={headerGroup.id} {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map(column => (
                  <th
                    key={column.id}
                    className={column.isSort ? "sorting" : ""}
                    style={{
                      position: "sticky",
                      top: 0,
                      zIndex: 1
                    }}
                  >
                    <div className="m-0" {...column.getSortByToggleProps()}>
                      {column.render("Header")}
                    </div>
                    {/* <Filter column={column} /> */}
                  </th>
                ))}
              </tr>
            ))}
          </thead>

          <tbody {...getTableBodyProps()}>
            {page.map(row => {
              prepareRow(row)
              return (
                <Fragment key={row.getRowProps().key}>
                  <tr>
                    {row.cells.map(cell => {
                      return (
                        <td key={cell.id} {...cell.getCellProps()}>
                          {cell.render("Cell")}
                        </td>
                      )
                    })}
                  </tr>
                </Fragment>
              )
            })}
          </tbody>
        </Table>
      </div>

      {isPagination && (
        <Row className="justify-content-between align-items-center">
          {isShowingPageLength && (
            <div className="col-sm">
              <div className="text-muted">
                Showing <span className="fw-semibold">{page.length}</span> of{" "}
                <span className="fw-semibold">{data.length}</span> entries
              </div>
            </div>
          )}
       <div className={paginationDiv}>
            <ul className={pagination}>
              <li className={`page-item ${!canPreviousPage ? "disabled" : ""}`}>
              <Link 
                to={`?pageIndex=${pageIndex - 1}`} 
                className="page-link" 
                onClick={(e) => {
                  e.preventDefault();
                  previousPage();
                }}
              >
                <i className="mdi mdi-chevron-left"></i>
              </Link>
            </li>
              {pageOptions.map((item, key) => {
                const totalPages = Math.ceil(data.length / pageSize)
                if (
                  item >= pageIndex - 4 &&
                  item <= pageIndex + 5 &&
                  item < totalPages
                ) {
                  return (
                    <li
                  className={
                    pageIndex === item ? "page-item active" : "page-item"
                  }
                  key={key}
                >
                  <Link
                    to={`?pageIndex=${item}`}
                    className="page-link"
                    onClick={(e) => {
                      e.preventDefault();
                      gotoPage(item);
                    }}
                  >
                    {item + 1}
                  </Link>
                </li>
                  )
                }
                return null
              })}
              <li className={`page-item ${!canNextPage ? "disabled" : ""}`}>
              <Link 
                to={`?pageIndex=${pageIndex + 1}`} 
                className="page-link" 
                onClick={(e) => {
                  e.preventDefault();
                  nextPage();
                }}
              >
                <i className="mdi mdi-chevron-right"></i>
              </Link>
            </li>
            </ul>
          </div>
        </Row>
      )}
    </Fragment>
  )
}

TableContainer.propTypes = {
  initialPageIndex: PropTypes.number,
  onPageChange: PropTypes.func,
  preGlobalFilteredRows: PropTypes.any,
}

export default TableContainer
